import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import styled from 'styled-components';
import ReactSVG from 'react-svg';
import { CSSTransition } from 'react-transition-group';

import { BoxCol } from 'components/Styled/Box';
import { useAnimationDelay } from 'components/Styled/Modal/utils/useDelay';
import { IconBorder, Content, CloseIcon } from '../Header.styles';
import permissions, { checkPermissions } from 'config/permissions';

const Wrap = styled(BoxCol)`
	box-sizing: border-box;
    position: absolute;
	display: flex;
	flex-direction: column;
    top: 48px;
    right: 0;
    box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.2), 0 0 2px 0 rgba(0, 0, 0, 0.4);
    margin: 0;
    min-width: 400px;
    max-width: 400px;
	height: calc(100% - 48px);
	z-index: 99999;
    
    .icon-close {
        cursor: pointer;
    }

	iframe {
		width: 100%;
		height: 100%;
	}
`;

const TARGET_EL = document.createElement('div');

document.body.appendChild(TARGET_EL);

const VirtualChat = () => {
	const [hasChatSession, setChatSession] = useState(false);

	const permission = checkPermissions(permissions.InternalChatOperations.action_manage);

	const {
		isOpened,
		handleClose,
		handleOpen,
	} = useAnimationDelay();

	useEffect(() => {
		setChatSession(isOpened || hasChatSession);
	}, [isOpened]);

	return permission && (
		<>
			<Content>
				<IconBorder onClick={handleOpen}>
					<ReactSVG src="data/svg/chat-centered-dots.svg" />
				</IconBorder>
			</Content>

			{createPortal(
				<CSSTransition
					appear
					enter
					exit
					mountOnEnter
					unmountOnExit
					in={isOpened}
					classNames="pageSliderRight"
					timeout={500}
				>
					<Wrap>
						<CloseIcon>
							<i className="icon icon-close" onClick={handleClose} />
						</CloseIcon>

						{hasChatSession && (
							<iframe src="https://n8n.ukc.gov.ua/webhook/53c136fe-3e77-4709-a143-fe82746dd8b6/chat" />
						)}
					</Wrap>
				</CSSTransition>,
				TARGET_EL,
			)}
		</>
	);
};

export default VirtualChat;
